module.exports = __webpack_public_path__ + "static/gallery10-832c27be6bcce27e4a53ed414fd6af44.jpg";